import RocketImg from "public/migrationToMost/rocket.png";
import CubesImg from "public/migrationToMost/cubes.png";
import LightImg from "public/migrationToMost/light.png";
import VerifyImg from "public/migrationToMost/verify.png";

export const MIGRATION_CONSTANTS = {
  TITLE: "OneMind’s Migration Playbook for Zadara ",
  ITEMS: [
    {
      image: RocketImg,
      title: "Discovery ",
      text: "We assess your workloads, architecture, dependencies, and licensing to map the best-fit migration approach into Zadara’s fully managed cloud or edge infrastructure. ",
    },
    {
      image: LightImg,
      title: "Planning & Architecture ",
      text: "Tailored roadmap including optimal integration with Zadara’s compute (zCompute), storage (zStorage), and networking (zNetworking), with hybrid and multi-cloud support. ",
    },
    {
      image: CubesImg,
      title: " Automation-Driven Migration ",
      text: "Using OneMind’s Xmost Migrator, plus Zadara’s built-in orchestration and APIs, we automate workload transitions with minimal downtime. ",
    },
    {
      image: VerifyImg,
      title: "Validation & Cutover ",
      text: "End-to-end testing, phased cutovers, rollback options, and optimization within Zadara’s secure, resilient platform.",
    },
  ],
};
